import { ServiceItem, ServiceType } from "./Types";

export const getServiceLabel = (item: ServiceItem) => {
  const typeMap: Record<ServiceType, string> = {
    port: "Port",
    internet: "Internet",
    dci: "Datacenter Interconnect",
    cloud: "Cloud",
    fwaas: "FWaaS"
  };
  const labelPrefix = typeMap[item.type] ?? "Service";
  const customerName = item.customer?.nameDisplay || item.customer?.name;
  const base = `[${labelPrefix}] ${item.name}`;
  return customerName ? `${customerName} • ${base}` : base;
};